export const mirroredFromOfferBudget = (lineItem) => {
  if (!lineItem) return false;

  return lineItem["mirrored_from_v3_budget?"] ?? lineItem["owned_by_offer_budget?"] ?? false;
};

export const ownedByOfferBudget = (lineItem) => {
  if (!lineItem) return false;

  return lineItem["owned_by_offer_budget?"] ?? lineItem["mirrored_from_v3_budget?"] ?? false;
};

export const ownedByStaffing = (lineItem) => lineItem?.["staffing?"] ?? false;
